import { css } from 'styled-components';
import { SidebarProps } from '@/shared/components/layout/components/sidebar/sidebar.types';

const styles = {
  container: css<SidebarProps>`
    background-color: ${({ theme }) => theme.colors.neutral.palette100};
    cursor: ${({ collapsed }) => (collapsed ? 'e-resize' : 'w-resize')};
  `,
  bottomContainer: () => css`
    display: flex;
    width: 100%;
    height: fit-content;
    align-items: center;
    justify-content: center;

    &:hover {
      cursor: pointer;
    }
  `,
};

export default styles;
